module.exports = __webpack_public_path__ + "static/laboheme3-37231832d3672c0627edd343451727c8.jpg";